import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import imgTour from '@/assets/img/tours/tours-07.jpg';

const TourSection = ({ title, subtitle, toursKey, fetchAction, limit = 4 }) => {
  const dispatch = useDispatch();
  const { [toursKey]: tours, loading, error } = useSelector((state) => state.tour);

  useEffect(() => {
    dispatch(fetchAction());
  }, [dispatch, fetchAction]);

  const mainSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: limit,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  const imageSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  const stripHtml = (html) => {
    return html
      .replace(/<[^>]+>/g, "\n")
      .replace(/\n+/g, "\n")
      .trim();
  };

  const displayedTours = Array.isArray(tours) ? tours.slice(0, limit) : tours ? [tours] : [];

  return (
    <section className="section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 wow fadeInUp" data-wow-delay="0.2s">
            <div className="section-header-six">
              <span className="badge badge-soft-primary rounded-pill mb-1">{title}</span>
              <h2>{subtitle}<span className="text-primary">.</span></h2>
            </div>
          </div>
          <div className="col-md-4">
            <div className="text-end">
              <Link to="/tour-list" className="btn btn-dark sec-head-btn">
                Xem tất cả <i className="isax isax-arrow-right-3 ms-2"></i>
              </Link>
            </div>
          </div>
        </div>

        {loading && <p>Loading...</p>}
        {error && <p className="text-danger">{error}</p>}

        {!loading && !error && displayedTours.length > 0 && (
          <Slider {...mainSliderSettings}>
            {displayedTours.map((tour) => {
              const plainDescription = stripHtml(tour.description || '');
              const activeDiscount = tour.discounts
                ?.filter(d => d.isActive)
                .sort((a, b) => b.discountPercentage - a.discountPercentage)[0];
              const originalPrice = tour.price || 0;
              const discountedPrice = activeDiscount
                ? originalPrice * (1 - activeDiscount.discountPercentage / 100)
                : originalPrice;
              const discountAmount = activeDiscount ? originalPrice - discountedPrice : 0;

              return (
                <div key={tour.tourId} className="place-item mb-4 px-2">
                  <div className="place-img">
                    <Slider {...imageSliderSettings} className="img-slider image-slide">
                      {tour.imageUrls?.length ? (
                        tour.imageUrls.map((imageUrl, index) => (
                          <div key={index} className="slide-images">
                            <Link to={`/tour-detail/${tour.tourId}`}>
                              <img
                                src={imageUrl}
                                className="img-fluid"
                                alt={tour.tourName}
                                style={{ height: "200px", objectFit: "cover" }}
                              />
                            </Link>
                          </div>
                        ))
                      ) : (
                        <div className="slide-images">
                          <Link to={`/tour-detail/${tour.tourId}`}>
                            <img
                              src={imgTour}
                              className="img-fluid"
                              alt="Tour Default"
                              style={{ height: "200px", objectFit: "cover" }}
                            />
                          </Link>
                        </div>
                      )}
                    </Slider>
                    <div className="fav-item">
                      <a href="#" className="fav-icon">
                        <i className="isax isax-heart5"></i>
                      </a>
                      <span className="badge bg-info d-inline-flex align-items-center">
                        <i className="isax isax-ranking me-1"></i>Trending
                      </span>
                    </div>
                  </div>
                  <div className="place-content">
                    <div className="d-flex align-items-center justify-content-between mb-1">
                      <div className="d-flex flex-wrap align-items-center">
                        <span className="me-1">
                          <i className="ti ti-receipt text-primary"></i>
                        </span>
                        <p className="fs-14 text-gray-9">
                          <Link to={`/tour-list?categoryId=${tour.categoryId}`}>
                            {tour.categoryName || 'Ecotourism'}
                          </Link>
                        </p>
                      </div>
                      <span className="d-inline-block border vertical-splits">
                        <span className="bg-light text-light d-flex align-items-center justify-content-center"></span>
                      </span>
                      <div className="d-flex align-items-center flex-wrap">
                        <span className="badge badge-warning badge-xs text-gray-9 fs-13 fw-medium me-1">
                          {tour.averageRating !== null ? tour.averageRating.toFixed(1) : '0'}
                        </span>
                        <p className="fs-14">({tour.reviewCount || 0} đánh giá)</p>
                      </div>
                    </div>
                    <h5 className="mb-1 text-truncate">
                      <Link to={`/tour-detail/${tour.tourId}`}>
                        {tour.tourName || 'Rainbow Mountain Valley'}
                      </Link>
                    </h5>
                    <p className="d-flex align-items-center mb-3" style={{ whiteSpace: "pre-line" }}>
                      <i className="isax isax-document-text me-2"></i>
                      {plainDescription.length > 80 ? `${plainDescription.substring(0, 80)}...` : plainDescription}
                    </p>
                    <div className="mb-3">
                      <h6 className="d-flex align-items-center text-gray-6 fs-14 fw-normal">
                        Giá{' '}
                        <span className="ms-1 fs-18 fw-semibold text-primary">
                          {discountedPrice.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })}
                        </span>
                        {activeDiscount && (
                          <>
                            <span className="ms-1 fs-18 fw-semibold text-gray-3 text-decoration-line-through">
                              {originalPrice.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })}
                            </span>
                          </>
                        )}
                      </h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-top pt-3">
                      <div className="d-flex flex-wrap align-items-center me-2">
                        <span className="me-1">
                          <i className="isax isax-calendar-tick text-gray-6"></i>
                        </span>
                        <p className="fs-14 text-gray-9">Số ngày: {tour.numberDay}</p>
                      </div>
                      <span className="d-inline-block border vertical-splits">
                        <span className="bg-light text-light d-flex align-items-center justify-content-center"></span>
                      </span>
                      <div className="ms-2 d-flex align-items-center">
                        <p className="fs-14 text-gray-9 mb-0 text-truncate d-flex align-items-center">
                          <i className="isax isax-profile-2user me-1"></i>
                          {tour.maxParticipants} du khách
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        )}
      </div>
    </section>
  );
};

export default TourSection;